import logo from './logo.svg';
import './App.css';
import Pong from './pong';

function App() {
  return (
    <Pong></Pong>
  );
}

export default App;
